import React, { useCallback } from "react";
import SidebarSearchInput from "./SidebarSearchInput";
import SidebarSearchResults from "./SidebarSearchResults";
import useSidebarSearch from "./useSidebarSearch";

const SidebarSearch = ({ arr, currentUrl, history }) => {
  const {
    query,
    results,
    highlightedIndex,
    handleQueryChange,
    handleClear,
    handleKeyDown,
    setHighlightedIndex,
  } = useSidebarSearch({ arr, currentUrl });

  const handleResultClick = useCallback(
    (item) => {
      window.scrollTo(0, 0);
      if (item.url || item.route) {
        history.push(item.url || item.route);
      }
      handleClear();
    },
    [history, handleClear],
  );

  return (
    <div className="sidebar-search">
      <SidebarSearchInput
        value={query}
        onChange={handleQueryChange}
        onClear={handleClear}
        onKeyDown={(event) => handleKeyDown(event, handleResultClick)}
      />
      <SidebarSearchResults
        results={results}
        highlightedIndex={highlightedIndex}
        onResultClick={handleResultClick}
        onItemHover={setHighlightedIndex}
        query={query}
      />
    </div>
  );
};

export default SidebarSearch;
